import React from 'react';
import { Briefcase, Users, UserPlus, Clock, TrendingUp, Percent } from 'lucide-react';

interface Props {
  totalVacancies: number;
  totalCandidates: number;
  totalHires: number;
  avgTimeToFill: number;
  avgCostPerHire: number;
  conversionRate: string;
}

const MetricsCards: React.FC<Props> = ({
  totalVacancies, totalCandidates, totalHires, avgTimeToFill, avgCostPerHire, conversionRate
}) => {
  const cards = [
    { icon: <Briefcase size={24} color="#fff" />, value: totalVacancies, label: 'Активных вакансий', color: '#2575fc' },
    { icon: <Users size={24} color="#fff" />, value: totalCandidates, label: 'Кандидатов', color: '#6a11cb' },
    { icon: <UserPlus size={24} color="#fff" />, value: totalHires, label: 'Наймов', color: '#10b981' },
    { icon: <Clock size={24} color="#fff" />, value: `${avgTimeToFill} дн.`, label: 'Средний срок закрытия', color: '#f59e0b' },
    { icon: <TrendingUp size={24} color="#fff" />, value: `${avgCostPerHire.toLocaleString()} ₽`, label: 'Стоимость найма', color: '#ef4444' },
    { icon: <Percent size={24} color="#fff" />, value: `${conversionRate}%`, label: 'Общая конверсия', color: '#06b6d4' },
  ];

  return (
    <div style={styles.grid}>
      {cards.map((card, idx) => (
        <div key={idx} style={styles.card}>
          <div style={{ ...styles.icon, background: card.color }}>{card.icon}</div>
          <div style={styles.info}>
            <span style={styles.value}>{card.value}</span>
            <span style={styles.label}>{card.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20, marginBottom: 30 },
  card: {
    background: 'rgba(255,255,255,0.7)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderRadius: 24,
    padding: '20px',
    boxShadow: '0 8px 32px rgba(31,38,135,0.1)',
    border: '1px solid rgba(255,255,255,0.4)',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    transition: 'transform 0.2s, box-shadow 0.2s',
    cursor: 'default',
  },
  icon: {
    width: 52,
    height: 52,
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  info: { display: 'flex', flexDirection: 'column', minWidth: 0 },
  value: { fontSize: 26, fontWeight: 800, color: '#1a1a2e', lineHeight: 1.2 },
  label: { fontSize: 13, color: '#64748b', marginTop: 4, fontWeight: 500 },
};

export default MetricsCards;
